import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hivimar',
  templateUrl: './hivimar.component.html',
  styleUrls: ['./hivimar.component.css']
})
export class HivimarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
